import axios from "@/repositories/client";

axios.getSheet = (hotel, query) => {

  let options = {
    params: {
      since: query.from,
      until: query.until,
      contract_id: query.contract.value
    }
  };

  return axios.get(`athena/v1/hotels/${hotel}/sheet`, options)
    .then(response => {
      return response.data;
    });
};

axios.updateInventory = (data) => {
  return axios({method: 'POST', url: `athena/v1/hotels/${data.hotel_id}/sheet/inventory`, data: [data]})
    .then(response => {
      return response.data;
    });
};

axios.updatePrice = (data) => {
  return axios({method: 'POST', url: `athena/v1/hotels/${data.hotel_id}/sheet/pricing`, data: [data]})
    .then(response => {
      return response.data;
    });
};

axios.bulkUpdateInventory = (hotel, data) => {
  return axios({method: 'POST', url: `athena/v1/hotels/${hotel}/sheet/inventory/bulk`, data: data})
    .then(response => {
      return response.data;
    });
};

axios.bulkUpdatePricing = (hotel, data) => {
  return axios({method: 'POST', url: `athena/v1/hotels/${hotel}/sheet/pricing/bulk`, data: data})
    .then(response => {
      return response.data;
    });
};

export default axios;